import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { InfoPlacement, InfoTheme, InfoLayer } = jest.requireActual('bloko/blocks/drop/Info/index.js');
export { InfoPlacement, InfoTheme, InfoLayer };

export default mockComponentRenderProp('DropInfo', null, {
    withChildren: true,
});
